module.exports = __webpack_public_path__ + "assets/img/warn.879dbdd2.png";